import { format } from 'date-fns'

import { LocalTime } from '@/gen/publicApi'

export const ISO_DATE_FORMAT = 'yyyy-MM-dd'
export const GRAPH_DATE_FORMAT = 'LLL dd'
export const GRAPH_MINUTE_FORMAT = 'HH:mm:ss'

export function toLocalTime(timeString: string): LocalTime {
    const [hour, minute] = timeString.split(':').map(Number)
    return {
        hour,
        minute,
        clockHourOfHalfDay: hour % 12 || 12,
        second: 0,
        millisecond: 0,
        tickOfSecond: 0,
        tickOfDay: hour * 3600000 + minute * 60000,
        nanosecondOfSecond: 0,
        nanosecondOfDay: (hour * 3600 + minute * 60) * 1e9,
    }
}

export function fromLocalTime(time: LocalTime): string {
    if (!time?.hour) {
        return '--'
    }
    const hour = time.hour.toString().padStart(2, '0')
    const minute = (time.minute || 0).toString().padStart(2, '0')
    return `${hour}:${minute}`
}

export function fromUtc(time: string): string {
    return format(new Date(time), ISO_DATE_FORMAT)
}
